import type {createContext} from "../context-shared";
import {extendLock, lock, set, unlock} from "../../utils/storage";
import {debug} from "../../utils/log";
import type {IStateStorage} from "../state";
import {abortValidation, requestValidation as request} from "./validation";
import {later} from "../../utils/basic";
import {ID_PREFIX} from "../../utils/constants";

let context: ReturnType<typeof createContext> | undefined;
let stateChannel: BroadcastChannel | undefined;

const LOCK_NAME = 'request-validation';
const impl = {
    lock(extend: boolean) {
        if (extend) {
            return extendLock(LOCK_NAME)
        }
        return lock(LOCK_NAME)
    },
    unlock() {
        return unlock(LOCK_NAME)
    },
    async saveAndBroadcast(state: IStateStorage) {
        debug("State updated:", state);
        await set('state', state)
        stateChannel!.postMessage({type: 'state-dump', state})
    }
}

export async function requestValidation() {
    if (!context) {
        throw new Error('Context not set');
    }
    return request(context.view, false, impl)
}

export function setup(ctx: ReturnType<typeof createContext>) {
    context = ctx
    stateChannel = new BroadcastChannel(`${ID_PREFIX}state`);
    stateChannel.addEventListener('message', async (event) => {
        const REQUEST_DUMP = 'request-dump';
        if (event.data.type === REQUEST_DUMP) {
            if (await lock(REQUEST_DUMP)) {
                await later(10)
                await unlock(REQUEST_DUMP)
                stateChannel!.postMessage({type: 'state-dump', state: ctx.view})
            }
        }
    })
    return Promise.resolve()
}

export function bfCacheRestore() {
    requestValidation()
}

export function onpagehide() {
    abortValidation()
    impl.unlock() // immediately unlock the lock since we are about to go to sleep and the normal unlock might take a while
}
